export default __webpack_public_path__ + "static/media/rocket_anim_48.087ed8f1.png";